/**
 * Creates deep clone of object. Does not support complex types in cloning - functions, etc.
 * @param {object} T
 */
export const deepClone = <T>(x: T): T => JSON.parse(JSON.stringify(x));
